import { Component, OnInit } from '@angular/core';
import { ContainerService } from '../../core/services/container.service';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { RouterModule } from '@angular/router';
import { NewButtonComponent } from '../../shared/components/new-button/new-button.component';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { Container } from '../../core/models/container.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { ContainerDetailComponent } from '../container-detail/container-detail.component';

@Component({
  selector: 'app-container-list',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    RouterModule,
    NewButtonComponent,
    ConfirmPopupComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    ContainerDetailComponent,
  ],
  templateUrl: './container-list.component.html',
  styleUrls: ['./container-list.component.scss'],
})
export class ContainerListComponent implements OnInit {
  containers: Container[] = [];
  flattenedData: any[] = [];
  containerToDelete: Container | null = null;
  selectedContainer: Container | null = null;
  tableColumns = [
    { header: 'ID', field: 'id' },
    { header: 'Cod. Oxy', field: 'codOxy' },
    { header: 'Cod. Red', field: 'codRed' },
    { header: 'Tipo', field: 'typecontainer' },
    { header: 'N° Serie', field: 'nroSerie' },
    { header: 'Cliente', field: 'client' },
    { header: 'Fecha Fab.', field: 'dateFabrication', isDate: true },
    { header: 'Fecha PH', field: 'dateHydraulicTest', isDate: true },
    { header: 'Tara', field: 'tara' },
    { header: 'Estado', field: 'disabled' },
  ];

  constructor(private containerService: ContainerService) {}

  ngOnInit(): void {
    this.getContainers();
  }

  getContainers(): void {
    this.containerService.getContainers().subscribe(containers => {
      this.containers = containers;
      this.flattenData();
    });
  }

  flattenData(): void {
    this.flattenedData = this.containers.map((item: any) => ({
      id: item.id,
      codOxy: item.codOxy || '',
      codRed: item.codRed || '',
      typecontainer: item.typePackaging.name || '',
      nroSerie: item.nroSerie || '',
      client: item.client.razonSocial || '',
      dateFabrication: item.dateFabrication || '',
      dateHydraulicTest: item.dateHydraulicTest || '',
      tara: item.tara || '',
      disabled: item.disabled || false,
    }));
  }

  confirmDelete(container: Container): void {
    this.containerToDelete = container;
  }

  onDeleteConfirm(): void {
    if (this.containerToDelete && this.containerToDelete.id !== undefined) {
      this.containerService.deleteContainer(this.containerToDelete.id).subscribe(() => {
        this.getContainers();
        this.containerToDelete = null;
      });
    }
  }

  onDeleteCancel(): void {
    this.containerToDelete = null;
  }

  toggleContainerStatus(container: Container): void {
    container.disabled = !container.disabled;
    this.containerService.disabledContainer(container).subscribe(() => {
      this.getContainers();
    });
  }

  selectContainer(container: Container): void {
    this.selectedContainer = container; // Asigna el envase seleccionado
  }

  closeContainerDetail(): void {
    this.selectedContainer = null; // Cierra el detalle del envase
  }
}
